export default {
  namespaced: true,

  state: {
    dark: false
  },

  getters: {
    DARK: state => {
      return state.dark
    }
  },

  mutations: {
    SET_DARK(state, payload) {
      state.dark = payload
    }
  },

  actions: {
    setIsDark(context, value) {
      context.commit('SET_DARK', value)
    }
  }
}
